"use client";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";
import { GetContentComponent } from "@/services/component.service";

const DynamicSectionComponent: React.FC<
  SectionProps<{
    rootComponent: any;
    bgColor: string;
    bgImage: string;
    align: {
      vertical: string;
      horizontal: string;
    };
  }>
> = ({ cmsSection, index, cmsData, app }) => {
  return (
    <SectionLayout
      cmsSection={getDefaultCmsSection(cmsSection, {
        width: "4xl",
        padding: "none",
      })}
    >
      <div className={`flex flex-1 h-full w-full section-${index}`}>
        {GetContentComponent(
          cmsData,
          cmsSection.specifics.rootComponent,
          `dynamic-content-${index}`,
          0,
          app
        )}
      </div>
    </SectionLayout>
  );
};

export default DynamicSectionComponent;
